module.exports = __webpack_public_path__ + "static/img/wan-fo-shen-xiang-you.f9c826d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/wan-fo-shen-xiang-you.jpeg
// module id = 1KoL
// module chunks = 1